module.exports = __webpack_public_path__ + "img/braendz-light.54daa2c7.svg";